<template>
    <div class="animated fadeIn is-background-dark1">
        <section class="section">
            <div class="columns is-centered">
                <div class="column content" style="flex: inherit">
                    <figure class="image download-app-img" v-if="!isMobile()">
                        <img alt="Download application" src="./assets/download-app.svg" width="300" height="300">
                    </figure>
                    <figure class="image download-app-img mobile-screen" v-else>
                        <img alt="Download application" src="./assets/download-app.svg" width="200" height="200">
                    </figure>
                </div>
            </div>
            <div class="padding-top-2x padding-bottom-2x">
                <div class="columns is-centered">
                    <div class="column intro-text content is-mobile">
                        <h3 class="is-size-3 small-container padding-bottom-1x uptin-text-center text-yellow">
                            {{ $t('home:download-app.header') }}
                        </h3>
                    </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container">
                        <p class="is-size- small-container uptin-text-center uptin-text-7 text-white">
                            {{ $t('home:download-app.description') }}
                        </p>
                    </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container padding-top-1x uptin-text-center">
                        <router-link :to="'get-app'" class="button uptin-splash-button is-background-yellow text-dark" active-class="is-active is-active--advertiser">
                            {{ $t('home:download-app.more_details') }}
                        </router-link>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<style lang="scss">

.download-app-img {
    max-width: 300px;
    min-width: 300px;
    margin: 2%;
    height: auto;

    &.position-top {
        top: -1em;
    }

    &.mobile-screen {
        max-width: 400px;
        min-width: 200px;
    }
}
</style>

<script>
export default {
    components: {
    },
    name: 'download-app',
    methods: {
        isMobile() {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        }
    }
}
</script>
